import { RegionId } from '../region-id.enum';
import { StripeProductType } from '../stripe-product-type';

/**
 * Filter parameters for GET /api/required-design-file-templates.
 */
export interface ListRequiredDesignFileTemplatesParams {
    readonly treatmentTypeOriginalId?: number | null;
    readonly treatmentSubTypeOriginalId?: number | null;
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly region?: RegionId | null;
    readonly stripeProductType?: StripeProductType | null;
    readonly isActive?: boolean | null;
    readonly search?: string | null;
}
